import { useQuery } from '@tanstack/react-query';
import invariant from 'tiny-invariant';

import { CustomFields } from '@air/api';

import { getCustomFieldOptionsKey } from '~/constants/react-query-keys';
import { ONE_HOUR } from '~/constants/unitsOfTime';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

type UseGetPrivateCustomFieldOptionsParams = {
  customFieldId?: string;
  enabled?: boolean;
};

export const useGetPrivateCustomFieldOptions = ({ customFieldId, enabled }: UseGetPrivateCustomFieldOptionsParams) => {
  const { currentWorkspace } = useCurrentWorkspace();
  const workspaceId = currentWorkspace?.id;

  return useQuery({
    queryKey: getCustomFieldOptionsKey(customFieldId),

    queryFn: () => {
      invariant(workspaceId, 'No workspace id');
      invariant(customFieldId, 'No custom field id');

      return CustomFields.listCustomFieldValues({ customFieldId, workspaceId });
    },
    enabled: !!workspaceId && !!customFieldId && enabled,
    staleTime: ONE_HOUR,
  });
};
